<template>
  <div>
    <div class="about text-center mt-5">
      <img
        src="https://res.cloudinary.com/caarea/image/upload/v1617955698/cs/assets/404_qktbda.png"
        alt="Logo 404"
      />
    </div>
    <div class="nav-next text-center">
      <p class="bold">{{ $t("error404") }}</p>
      <p>{{ $t("error.continue") }}</p>
    </div>

    <div class="nav-next text-center">
      <button
        class="btn btn-primary"
        data-cy="home-btn"
        @click.prevent="pushI18nRoute({ name: getUrlName })"
      >
        {{ $t("button.home") }}
      </button>
    </div>
  </div>
</template>
<script>
import ErrorPageMixin from "@/mixins/ErrorPageMixin"
export default {
  name: "Page404",
  mixins: [ErrorPageMixin],
}
</script>
